// extracted by mini-css-extract-plugin
module.exports = {"dropdownItemSm":"AcDropdownItem_dropdownItemSm__15He_","dropdownItemLg":"AcDropdownItem_dropdownItemLg__2nRRP","dropdownItemXl":"AcDropdownItem_dropdownItemXl__ZxRyZ"};